<template>
    <div class="success-box">
        <img src="../assets/image/success-icon.png" class="success-img">
        <p>投屏连接成功啦！</p>
        <p>快进入班课点击资源、签到和活动投屏吧~</p>
    </div>
</template>

<script>
export default {
    props: {
        currentShow: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {

        };
    },

    computed:{
    },


    watch:{

    },
    

    created: function() {

    },
    mounted: function() {
        this.componentId = this.$attrs.id;
    },

    
    methods:{
        
    }
};
</script>

<style>
    .success-box {
        z-index: 99;
        background-color: #252525;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .success-img {
        width: 380px;
        height: 140px;
        margin-bottom: 40px;
    }

    .success-box p {
        font-size: 48px;
        color: #ffffff;
    }
</style>